export enum SubscriptionPeriod {
  YEARLY = 'yearly',
  MONTHLY = 'monthly',
}

export enum SubscriptionTypesEnum {
  MONTHLY = 1,
  YEARLY = 2,
}
